import React from 'react';
import ResetPasswordLayout from './components/ResetPasswordLayout';
import ResetPasswordForm from './components/ResetPasswordForm';
import { useResetPassword } from './hooks/useResetPassword';

const ResetPassword = () => {
  const {
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    loading,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    currentImageIndex,
    setCurrentImageIndex,
    errors,
    handleSubmit
  } = useResetPassword();

  return (
    <ResetPasswordLayout
      currentImageIndex={currentImageIndex}
      setCurrentImageIndex={setCurrentImageIndex}
    >
      <ResetPasswordForm
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        loading={loading}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        showConfirmPassword={showConfirmPassword}
        setShowConfirmPassword={setShowConfirmPassword}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </ResetPasswordLayout>
  );
};

export default ResetPassword;
